/**
 * Created by 唐亦慧 on 2018/2/6.
 */
import React from 'react';
import {hashHistory} from 'react-router';
import {
  Layout,
  Table,
  Button,
  Card,
  Row,
  Col,
  Icon,
  Modal,
  Select,
  Form,
  Input,
  Radio,
} from 'antd';
import {
  DmsTab,
} from 'Components';
import '../mallApp.css';
import { sKeylist } from '../../service/dictionary/dataitem';
import {
  firstChannelListByPage, // 获取发货仓库
  createSecondOrder,
} from '../../service/order';
import {
  getXiaFu, // 下浮率
} from '../../service/thingsOrder';
import {
  getGoodsList as getAddressList, // 收货地址
} from '../../service/customerManagement';
import {
  openNotice,
  returnFloat,
  showSpin,
  hideSpin,
  config
} from 'Utils';

const { Header } = Layout;
const Option = Select.Option;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { TextArea } = Input;
const FormItem = Form.Item;

class SettleAccounts extends React.Component {
  constructor(props) {
    super(props);
    const orderList = JSON.parse(window.sessionStorage.getItem('list_orders') || '[]');
    this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
    this.state = {
      allCount: 0, // 订单产品总数量
      amount: 0, // 订单基于原价的总金额
      totalDiscount: 0, // 总优惠
      fare: 0, // 运费
      /////////
      visibleFlag: false,//弹出框显示
      productList: orderList,
      storeList: [],
      addressList: [],
      deliverType: [],
    };
  }

  componentDidMount() {
    const productList = [...this.state.productList];
    const promises = [];
    let amount = 0;
    let allCount = 0;
    let totalDiscount = 0; // 总优惠
    productList.forEach(x => {
      allCount += x.count;
      amount += Math.round((x.currentPrice * 100) * x.count) * 0.01;
      promises.push(getXiaFu({
        cusId: this.userData.empId,
        proId: x.productId,
        proType: 2,
      }));
    });
    this.setState({ amount, allCount });
    // 批量获取产品下浮率
    Promise.all(promises).then((posts) => {
      posts.forEach((x, index) => {
        let product = { ...productList[index] };
        let priceRate = x.data.priceRate || 0;
        let unitPrice = Math.ceil((product.currentPrice || product.originalPrice) * (100 - priceRate)) * 0.01; //下浮后的价格
        let sumPrice = unitPrice * product.count; // 基于下浮价格的小计
        let discountAmount = product.currentPrice * product.count - sumPrice; // 优惠的金额
        totalDiscount += discountAmount;
        productList.splice(index, 1, {
          ...product,
          unitPrice,
          sumPrice,
          discountAmount,
        });
      });
      this.setState({ productList, totalDiscount });
    }).catch(() => {
      openNotice('error', '获取产品下浮率失败');
    });
    // 获取仓库
    firstChannelListByPage().then(res => {
      this.setState({ storeList: res.data || [] });
    });
    // 获取地址
    getAddressList({
      p: 1,
      s: 100,
      source: 1,
      cusId: this.userData.roleCode === 'SECOND_CUSTOMER' ? this.userData.empId : this.userData.fatherId,
    }).then((res) => {
      this.setState({ addressList: res.data || [] });
    });
    // 获取送货方式
    sKeylist({ sKey: 'deliver_type' }).then((res) => {
      if (res.status) {
        this.setState({
          deliverType: (res.data || []).map(x => ({ text: x.name, value: x.sKey })),
        });
      }
    });
  }

  //提交订单
  submitOrder = (e) => {
    e.preventDefault();
    const {
      productList, totalDiscount, amount, fare
    } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        const params = {
          'amount': amount, //合计
          'cusId': this.userData.empId, //客户ID
          'sortName': this.userData.empId, //客户ID
          'discountRate': 100, //订单整体折扣(%)
          // 'discountRate': Math.random((totalDiscount/amount)*100), //订单整体折扣(%)
          'operateName': this.userData.userName, //操作员
          // 'orderDate': '2020-12-11 15:48:60', //订单日期（下单）
          'orderType': '2',//订单类型(1销售出库和2零售单3退货单) -----只传2
          'disCountAmount': totalDiscount, //优惠金额
          'payType': '现金', //收款方式-----只传现金
          /*'productList': [ //订单商品
            {
              'productId': '491', //产品id
              'priceRate': '0', //下浮率
              'count': '1', //数量
              'unitPrice': 85.4, //价格
              'sumPrice': '85.4', //小计
              'currentPrice': 85.4, //价格(当前)
              'productType': 2, //产品类别1其他产品2Erp产品
              'remark': null, //remark
              'unit': 'EA', //单位
              'originalPrice': null, //历史价格
            },
          ],*/
          productList: productList,
          'receivedAmount': amount + fare - totalDiscount, //实收总额
          'remark': values.remark, //备注
          'storageId': values.storageId, //仓库ID
          'deliveryType': values.deliveryType, //配送方式（1：快递；2：上门自提）
          'linkman': values.linkman, //收货人
          'telephone': values.telephone, //收货人手机号码
          'address': values.address, //收货地址
        };
        showSpin();
        createSecondOrder(params).then(res => {
          hideSpin();
          res.status && hashHistory.push(`/thingsOrder?code=${res.data.code}`);
          res.status && window.sessionStorage.removeItem('list_orders');
          res.status && openNotice('success', '操作成功');
          !res.status && openNotice('error', '提交订单失败');
        })
      }
    });
  };

  //弹出框
  handleOk = () => {
    this.handleCancel();
  };

  handleCancel = () => {
    this.setState({
      visibleFlag: false,
    });
  };

  selectAddress = (index) => {
    let item = this.state.addressList[index];
    let addressList = this.state.addressList.map((x, i) => ({
      ...x,
      checked: index === i,
    }));
    this.setState({
      addressList,
      visibleFlag: false,
    }, () => {
      this.props.form.setFieldsValue({
        linkman: item.recipientName,
        telephone: item.mobile,
        address: `${item.province || ''}${item.city || ''}${item.county || ''}${item.detailAddress || ''}`,
      });
    });
  };

  render() {
    const {
      isOrder, productList, visibleFlag,
      storeList, addressList, deliverType,
      amount, allCount, totalDiscount, fare,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const tabelProps = {
      className: 'gray-table',
      rowKey: 'productId',
      pagination: false,
      columns: [
        {
          title: <span>&emsp;</span>,
          dataIndex: 'picUrl',
          key: 'picUrl',
          width: 82,
          render: picUrl => <img className='pay-img'
                                 src={picUrl ? `${config.server}${picUrl}` : require('../../assets/images/product-default.png')}
                                 alt="" />,
        }, {
          title: '商品信息',
          dataIndex: 'name',
          key: 'name',
        }, {
          title: '物料编码',
          dataIndex: 'productCode',
          key: 'productCode',
        }, {
          title: '牌价',
          dataIndex: 'currentPrice',
          key: 'currentPrice',
          render: val => <span className="dms-red">¥ {val}</span>,
        }, {
          title: '下浮',
          dataIndex: 'priceRate',
          key: 'priceRate',
        }, {
          title: '数量',
          dataIndex: 'count',
          key: 'count',
        }, {
          title: '小计',
          dataIndex: 'sumPrice',
          key: 'sumPrice',
          render: val => <span className="dms-red">¥ {val}</span>,
        },
      ],
      dataSource: productList,
    };
    const modalProps = {
      visible: visibleFlag,
      title: '选择地址',
      width: 1000,
      bodyStyle: {
        maxHeight: 500,
        overflow: 'scroll',
      },
      // onOk: this.handleOk,
      onCancel: this.handleCancel,
      footer: [],
    };
    return <div>
      <Layout style={{ background: '#fff' }}>
        <Header id='mall-cart'>
          <div className="cart-word">结 算 页</div>
          <div className="pay-step">
            <div className='step-child'>
              <p>1</p>
              <p>1.我的购物车</p>
            </div>
            <div className='step-child'>
              <p>2</p>
              <p>2.填写核对订单信息</p>
            </div>
            <div className='step-child'>
              <p>3</p>
              <p>3.成功提交订单</p>
            </div>
          </div>

          <div className="header-left" onClick={() => hashHistory.push('/mallHome')}>
            <i style={{ fontSize: '18px' }} className="dmsIcon dmsHome"></i>
            <span style={{ paddingLeft: '12px' }}>首页</span>
          </div>
          <div className="header-right">
            <div className='mall-nav'
                 onClick={() => hashHistory.push('/mallCommon/userCenter/userInfo')}>
              <sapn className='nav-word comIcon userIcon'></sapn>
            </div>
          </div>
        </Header>
      </Layout>
      <div style={{ padding: '0 50px 10px 50px', background: '#fff' }}>
        <Form>
          <DmsTab className="white-bg no-border" options={['配送清单']} defaultKey={0}></DmsTab>
          <div style={{ padding: '10px 14px 20px', background: '#f7f7f7', marginBottom: 24 }}>
            <Row gutter={16}>
              <Col span={8} style={{ borderRight: 'solid 1px #ddd' }}>
                <FormItem label="发货仓库">
                  {
                    getFieldDecorator('storageId', {
                      relus: [
                        { require: true, message: '请选择发货仓库' },
                      ],
                    })(<Select style={{ width: 200 }} placeholder="请选择发货仓库">
                      {storeList.map(x => <Option key={`${x.id}`}>{x.subStoreName}</Option>)}
                    </Select>)
                  }
                </FormItem>
                <FormItem label="订单类型">
                  {
                    getFieldDecorator('orderType', {
                      initialValue: '2',
                      relus: [
                        { require: true, message: '请选择订单类型' },
                      ],
                    })(<Select style={{ width: 200 }}>
                      <Option key="2">零售单</Option>
                    </Select>)
                  }
                </FormItem>
              </Col>
              <Col span={16} style={{ paddingLeft: 16 }}>
                <FormItem
                  label="配送方式"
                >
                  {getFieldDecorator('deliveryType', {
                    // initialValue: deliverType.length ? deliverType[deliverType.length - 1].value : undefined,
                    initialValue: undefined,
                    relus: [
                      { require: true, message: '请选择配送方式' },
                    ],
                  })(
                    <RadioGroup>
                      {/*{ //1：快递；2：上门自提
                        deliverType.map(x => <span><RadioButton value={x.value}>{x.text}</RadioButton>&emsp;</span>)
                      }*/}
                      <span><RadioButton value="1">快递</RadioButton>&emsp;</span>
                      <span><RadioButton value="2">上门自提</RadioButton>&emsp;</span>
                    </RadioGroup>,
                  )}
                </FormItem>
                <FormItem
                  label={<span>收货地址：&emsp;
                    <Button onClick={() => this.setState({ visibleFlag: true })}>选择地址</Button></span>}
                  colon={false}
                >
                  {getFieldDecorator('address', {
                    relus: [
                      { require: true, message: '请选择收货地址' },
                    ],
                  })(<Input style={{ display: 'none' }} />)}
                </FormItem>
                <div style={{ display: 'none' }}>
                  <FormItem
                    label="收货人"
                    hidden
                  >
                    {getFieldDecorator('linkman', {
                      relus: [
                        { require: true, message: '请选择收货地址' },
                      ],
                    })(<Input />)}</FormItem>
                  <FormItem
                    label="收货人手机号码"
                    hidden
                  >
                    {getFieldDecorator('telephone', {
                      relus: [
                        { require: true, message: '请选择收货地址' },
                      ],
                    })(<Input />)}</FormItem>
                </div>
                {
                  addressList.filter(x => !!x.checked).map((item, index) => <Card key={index}
                                                                                  title={item.recipientName}
                                                                                  noHovering
                                                                                  className="currentAddress"
                                                                                  bodyStyle={{
                                                                                    padding: '12px',
                                                                                    height: '80px',
                                                                                  }}>
                    <h4>{item.recipientName} {item.mobile}</h4>
                    <p>{`${item.province || ''}${item.city || ''}${item.county || ''}`} {item.detailAddress}</p>
                  </Card>)
                }
              </Col>
            </Row>
            <div className="dms-split-bar" />
            <Table {...tabelProps} />
          </div>
          <DmsTab className="white-bg no-border" options={['备注']} defaultKey={0}></DmsTab>
          <FormItem label={null} colon={false}>
            {getFieldDecorator('remark', {
              rules: [
                { required: true, message: '请输入备注' },
                { max: 30, message: '最多可输入30个字符' },
              ],
            })(
              <TextArea row={4} placeholder="给商家留言，30字以内" />,
            )}
          </FormItem>
        </Form>
        <div className='sum-money clear'>
          <div>
            <p>已选 {allCount} 件商品&emsp;&emsp;小计：￥{amount}</p>
            <p>优惠金额：{returnFloat(totalDiscount)}</p>
            <p>配送费：{returnFloat(fare)}</p>
          </div>
        </div>
        <div className="final-pay">
          <div className='clear'>
            <div className="final-right">
              {/*订单实际金额 = 订单基于原价的总金额 + 运费 - 优惠金额 */}
              <p>
                订单实际金额：<span>{returnFloat(amount + fare - totalDiscount)}</span>
              </p>
              <button className={(productList.length === 0) ? 'no-product' : ''}
                      onClick={this.submitOrder}>
                提交订单
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal {...modalProps}>
        <div style={{ overflow: 'hidden', padding: '10px 0' }}>
          <Row gutter={16}>
            {
              addressList.map((item, index) => <Col key={index} span={8}>
                <Card title={item.recipientName}
                      noHovering
                      className={!!item.checked ? 'currentAddress' : ''}
                      bodyStyle={{ padding: '12px', height: '80px' }}
                      onClick={() => this.selectAddress(index)}>
                  <h4>{item.recipientName} {item.mobile}</h4>
                  <p>{`${item.province || ''}${item.city || ''}${item.county || ''}`} {item.detailAddress}</p>
                </Card>
              </Col>)
            }
          </Row>

        </div>
      </Modal>
    </div>;
  }
}
;
export default Form.create()(SettleAccounts);



// WEBPACK FOOTER //
// ./src/mall/mallPay/settleAccounts.js